import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class ApiAttributesValidatorService {

  constructor(
    private apiBasic: ApiBasicService
  ) { }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
   getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'attr_validators');
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('attr_validators', params);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  edit(id: string): Observable<Res> {

    return this.apiBasic.edit('attr_validators', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('attr_validators', params);
  }

  /**
   * 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('attr_validators', params);
  }

}